const QUERY =
  "query clubMatchesAssignations($clubId: ID!, $language: Language!, $startDate: String!, $endDate: String!, $hasLocation: Boolean!) { clubMatchesAssignations(clubId: $clubId, language: $language, startDate: $startDate, endDate: $endDate, hasLocation: $hasLocation) { id state title startTime ageGroup series { id } homeTeam { name clubId id logo } awayTeam { name clubId id logo } outcome { status } } }";
const QUERY_SCORES = QUERY.replace("outcome { status }", "outcome { status homeTeamGoals awayTeamGoals }");

const SRC = `(async()=>{try{var m=location.pathname.match(/club\\/(\\d+)/);var id=m?m[1]:prompt("Numéro du club (matricule FFA) ?");if(!id)return;var p=function(n){return(n<10?"0":"")+n};var f=function(x){return x.getFullYear()+"-"+p(x.getMonth()+1)+"-"+p(x.getDate())};var d=new Date();var sun=new Date(d);sun.setDate(d.getDate()+((7-d.getDay())%7));var mon=new Date(sun);mon.setDate(sun.getDate()-6);var s=prompt("Premier jour (AAAA-MM-JJ)",f(mon));if(!s)return;var e=prompt("Dernier jour (AAAA-MM-JJ)",f(sun));if(!e)return;var end=new Date(e+"T12:00:00");end.setDate(end.getDate()+1);var q=async function(query){var r=await fetch("https://datalake-prod2018.rbfa.be/graphql",{method:"POST",headers:{"content-type":"application/json"},body:JSON.stringify({operationName:"clubMatchesAssignations",query:query,variables:{clubId:id,language:"fr",startDate:s.replace(/-/g,"/"),endDate:f(end).replace(/-/g,"/"),hasLocation:true}})});return r.json()};var sc=true;var j=await q(${JSON.stringify(QUERY_SCORES)});if(j.errors||!j.data){sc=false;j=await q(${JSON.stringify(QUERY)})}var l=(j.data&&j.data.clubMatchesAssignations)||[];var n=l.filter(function(x){return x.outcome&&x.outcome.homeTeamGoals!=null}).length;var out=JSON.stringify({source:"ffa",clubId:id,scores:sc,matches:l});try{await navigator.clipboard.writeText(out);alert(l.length+" match(s) copié(s)"+(sc?", dont "+n+" avec score":" (scores indisponibles)")+" ! Retournez dans l'appli : Importer le calendrier > FFA > collez (Ctrl+V).")}catch(x){prompt("Copiez ce texte (Ctrl+C) puis collez-le dans l'appli :",out)}}catch(err){alert("Erreur FFA : "+err.message)}})();`;

export const FFA_BOOKMARKLET = "javascript:" + encodeURIComponent(SRC);

const uid = () => (crypto?.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2));
const DAYS = ["DIMANCHE", "LUNDI", "MARDI", "MERCREDI", "JEUDI", "VENDREDI", "SAMEDI"];
const WEEKEND = ["SAMEDI", "DIMANCHE", ""];
const up = (s) => (s || "").trim().toUpperCase();

const categoryOf = (m, ours) => {
  const ag = up(m.ageGroup);
  const title = up(m.title);
  const u = ag.match(/U\s?\d{1,2}/) || title.match(/U\s?\d{1,2}/);
  if (u) {
    const suffix = (up(ours?.name).match(/\s([A-H])(\s+\d{1,2})?$/) || [])[1] || "";
    return { cat: u[0].replace(/\s/, "") + suffix, senior: false };
  }
  const s = title.match(/\b([PDR])\s?(\d)\b/);
  return { cat: s ? s[1] + s[2] : (title.split(/\s+/)[0] || "SEN"), senior: true };
};

const isOurHome = (home, clubId) => (clubId ? String(home.clubId) === clubId : /JAPPES|JEMAPPES/i.test(home.name || ""));

const splitTime = (startTime) => {
  const [, date = "", hh = "0", mm = "00"] = (startTime || "").match(/^(\d{4}-\d{2}-\d{2})T(\d{2}):(\d{2})/) || [];
  const dt = new Date(`${date}T12:00:00`);
  const valid = !isNaN(dt);
  return { date, hh, mm, valid, dayName: valid ? DAYS[dt.getDay()] : "" };
};

const goal = (v) => (v === null || v === undefined || v === "" || isNaN(+v) ? null : +v);
const scoreOf = (o) => {
  const h = goal(o?.homeTeamGoals);
  const a = goal(o?.awayTeamGoals);
  return h === null || a === null ? "" : `${h}-${a}`;
};

const isForfeit = (m) => /forfeit|forfait/i.test(`${m.state || ""} ${m.outcome?.status || ""}`);

const normalizeMatch = (m, clubId, teamName) => {
  const home = m.homeTeam || {};
  const away = m.awayTeam || {};
  const homeOurs = isOurHome(home, clubId);
  const opp = homeOurs ? away : home;
  const oppName = up(opp.name);
  const t = splitTime(m.startTime);
  const forfeit = isForfeit(m);
  return {
    ...t, ...categoryOf(m, homeOurs ? home : away),
    oppName, oppLogo: opp.logo,
    match: homeOurs ? `${teamName} - ${oppName}` : `${oppName} - ${teamName}`,
    seniorTime: forfeit ? "F.G." : t.mm === "00" ? `${+t.hh}H` : `${+t.hh}H${t.mm}`,
    youthTime: forfeit ? "F.G." : `${+t.hh}H${t.mm}`,
    score: forfeit ? "F.G." : scoreOf(m.outcome),
  };
};

const readList = (text) => {
  let json;
  try { json = JSON.parse((text || "").trim()); } catch { return null; }
  const list = Array.isArray(json) ? json : json?.matches;
  return Array.isArray(list) ? { list, clubId: String(json.clubId || ""), scores: json.scores } : null;
};

export const parseFfa = (text, teamName = "USC") => {
  const input = readList(text);
  if (!input) return null;
  const days = new Map();
  const footer = [];
  const logos = new Map();

  [...input.list].sort((a, b) => (a.startTime || "").localeCompare(b.startTime || "")).forEach((raw) => {
    const m = normalizeMatch(raw, input.clubId, teamName);
    if (m.oppLogo && m.oppName) logos.set(m.oppName, m.oppLogo);
    if (m.senior) {
      footer.push({ id: uid(), cat: m.cat, match: m.match, day: m.dayName, time: m.seniorTime, score: m.score });
      return;
    }
    const header = m.valid ? `${m.dayName} ${m.date.slice(8, 10)}/${m.date.slice(5, 7)}` : "";
    if (!days.has(header)) days.set(header, { id: uid(), header, rows: [], week: !WEEKEND.includes(m.dayName), short: m.dayName.slice(0, 3) });
    days.get(header).rows.push({ id: uid(), cat: m.cat, match: m.match, time: m.youthTime, score: m.score });
  });

  const all = [...days.values()];
  const week = all.filter((d) => d.week);
  const many = week.length > 1;
  return {
    top: {
      header: week.map((d) => (many ? d.header.replace(d.header.split(" ")[0], d.short) : d.header)).join(" · "),
      rows: week.flatMap((d) => d.rows.map((r) => (many ? { ...r, time: `${d.short} ${r.time}` } : r))),
    },
    cols: all.filter((d) => !d.week).map(({ id, header, rows }) => ({ id, header, rows })),
    footer,
    logos: [...logos.entries()].map(([name, url]) => ({ name, url })),
    scoresAvailable: input.scores !== false,
  };
};

const norm = (v) => up(v).replace(/[^A-Z0-9]/g, "");
const allRows = (p) => [...p.top.rows, ...p.cols.flatMap((c) => c.rows), ...p.footer];

const findScore = (row, pool) => {
  const same = pool.filter((r) => norm(r.match) === norm(row.match));
  const hit = same.length > 1 ? same.find((r) => norm(row.cat).startsWith(norm(r.cat))) || same[0] : same[0];
  return hit?.score || "";
};

export const fillScores = (data, parsed) => {
  const pool = allRows(parsed).filter((r) => r.score);
  let filled = 0;
  let missing = 0;
  const apply = (rows = []) => rows.map((row) => {
    const score = findScore(row, pool);
    if (!score) { missing += 1; return row; }
    filled += 1;
    return { ...row, score };
  });
  const next = {
    ...data,
    show_scores: true,
    top: { ...(data.top || {}), rows: apply(data.top?.rows) },
    columns: (data.columns || []).map((c) => ({ ...c, rows: apply(c.rows) })),
    footer: apply(data.footer),
  };
  return { next, filled, missing };
};
